
import { getProductLocation, getFinisherByName, getProductModel } from '@/api';
import { Header, ProductLocation } from '@/models/main';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Autocomplete from './Autocomplete.vue';
import AutocompleteFinisher from './AutocompleteFinisher.vue';

import {
  installationOptions,
  installationOptionsText,
  returnOptions,
  returnOptionsList,
  returnOptionsTexts,
} from '@/utils/PortalConstants';
import { JobProducts, JobProductsHiddenData } from '@/models/jobData';

@Component({
  components: {
    Autocomplete,
    AutocompleteFinisher,
  },
  data() {
    return {
      installationOptions,
      installationOptionsText,
      returnOptions,
      returnOptionsList,
      returnOptionsTexts,
    };
  },
})
export default class ProductsWarehouse extends Vue {
  @Prop(Array) public readonly products: JobProducts[];
  @Prop(String) public readonly customerCode: string;

  public autocompleteModel = getProductModel;
  public tabItemsPrevCount = 10; // 10 actually for now

  public tableHeaders: Header[] = [
    { text: 'Model', value: 'model' },
    { text: 'Description', value: 'description' },
    { text: 'Serial number', value: 'serial' },
    { text: 'Quantity', value: 'quantity' },
  ];

  private defaultTableValue: JobProducts = {
    model: '',
    model_id: -1,
    description: '',
    serial: '',
    quantity: 1,
    from_stop: 1,
    to_stop: 2,
    weight: 0,
    runup: false,
    quant_id: null,
    installation: 'DLVONLY',
    returns: '',
  };
  private goods: JobProducts[] = [{ ...this.defaultTableValue }];
  public productsHiddenData: JobProductsHiddenData[] = [];

  public stopGoodsCounter = 1;

  //

  // endpoints
  public changeModel(stop, item) {
    this.products[stop].model = item.name;
    this.products[stop].model_id = item.product_id;
  }

  /**
   * Used from child components by emit()
   * @param stop
   * @private
   */
  private clear(stop: number) {
    this.products[stop].model = '';
    this.products[stop].model_id = -1;
    this.productsHiddenData[stop].serialNumberFilled = false;
    this.productsHiddenData[stop].statusText = '';
  }

  public async blur(event, stop) {
    const product_id = this.products[stop].model_id;
    const serial_number = event.target.value;
    this.productsHiddenData[stop].serialNumberFilled = false;
    this.productsHiddenData[stop].statusText = '';

    if (!!product_id && !!serial_number) {
      await this.getProductLocationWrapper(product_id, serial_number, stop);
    }
  }

  private async getProductLocationWrapper(product_id: number, serial_number: string, idx: number) {
    await getProductLocation(product_id, serial_number)
      .then((res: ProductLocation) => {
        let inputText = '';
        if (Object.keys(res).length >= 1) {
          inputText = `Warehouse: ${res.warehouse}, Status: ${res.name}`;
        } else {
          inputText = 'Out of stock';
        }
        this.products[idx].quantity = 1;
        this.productsHiddenData[idx].serialNumberFilled = true;
        this.productsHiddenData[idx].statusText = inputText;
      })
      .catch(() => {
        this.productsHiddenData[idx].statusText = 'Out of stock';
      })
      .finally(() => {
        this.$emit('changeProducts', this.products);
      });
  }

  public addMachine(): void {
    this.products.push({
      model: '',
      model_id: -1,
      description: '',
      serial: '',
      quantity: 1,
      installation: 'DLVONLY',
      from_stop: 1,
      to_stop: 2,
      weight: 0,
      runup: false,
      returns: '',
      quant_id: null,
    });
    this.productsHiddenData.push({
      serialNumberFilled: false,
      statusText: '',
    });
  }

  public addFinisher(): void {
    const lastIndex = this.products?.length - 1;
    this.products.push({
      ...this.defaultTableValue,
      model: '',
      model_id: -1,
      installation: this.products[lastIndex]?.installation || '',
    });
    this.productsHiddenData.push({
      serialNumberFilled: false,
      statusText: '',
    });
  }

  public async autocompleteFinisher(model, customer) {
    let responce = await getFinisherByName(model, customer);
    // TODO: change default name & id?
    responce = [...responce, { name: 'AA-FINISHER', product_id: 6182 }];
    return responce;
  }

  public deleteItem(item: JobProducts): void {
    this.products.splice(this.products.indexOf(item), 1);
  }

  @Watch('products', { deep: true })
  private watchToProducts(): void {
    if (this.products) {
      this.stopGoodsCounter = this.products?.length + 1;

      this.products.map((product, idx) => {
        if (!this.productsHiddenData[idx]) {
          this.productsHiddenData.push({
            serialNumberFilled: false,
            statusText: '',
          });
        }
        if (!!product.serial && !this.productsHiddenData[idx].serialNumberFilled && product.model_id) {
          this.getProductLocationWrapper(product.model_id, product.serial, idx);
        }
      });

      this.productsHiddenData.length = this.products.length;
    }
  }

  public decrementQuantity(item: JobProducts): void {
    if (
      !this.productsHiddenData[this.products.indexOf(item)].serialNumberFilled &&
      this.products[this.products.indexOf(item)].quantity > 1
    ) {
      this.products[this.products.indexOf(item)].quantity -= 1;
    }
  }

  public incrementQuantity(item: JobProducts): void {
    if (!this.productsHiddenData[this.products.indexOf(item)].serialNumberFilled) {
      this.products[this.products.indexOf(item)].quantity += 1;
    }
  }
}
